function easeInOutQuad(currentTime, start, diff, duration) {
  let time = currentTime / (duration / 2);

  if (time < 1) {
    return start + diff / 2 * time * time;
  }

  time--;

  return start - diff / 2 * (time * (time - 2) - 1);
}

export function scrollTo(end, options = {}) {
  const duration = typeof options.duration === 'number' ? options.duration : 500;
  const offsetY = typeof options.offsetY === 'number' ? options.offsetY : 100;
  const start = window.pageYOffset;
  let to = end;

  if (typeof end === 'string') {
    const element = document.getElementById(end);
    to = start + element.getBoundingClientRect().top;
  }

  to -= offsetY;

  const diff = to - start;
  let currentTime = 0;
  const animate = () => {
    currentTime += 20;
    window.scrollTo(0, easeInOutQuad(currentTime, start, diff, duration));

    if (currentTime < duration) {
      window.requestAnimationFrame(animate);
    } else {
      window.scrollTo(0, to);

      if (typeof end === 'string') {
        window.location.hash = `#${end}`;
      }
    }
  };

  animate();
}
